/**
 * Created by Pawel Grzyb 01.04.2018
 *
 * Schedule page.
 */

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grafik-page',
  templateUrl: './schedule-page.component.html',
  styleUrls: ['./schedule-page.component.css']
})
export class SchedulePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
